/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerCompanyStageDtoSchema = z.object({
  stage: z.optional(z.string()),
  description: z.optional(z.string()),
});
